import React, { useEffect } from 'react';
import Parser from 'html-react-parser';
import './Modal.css';   

const InfoModal = ({ show, onClose, title, data, small, isSubmitted }) => {
    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        const contentToPrint = typeof data === 'string' ? data : data?.content || '';
        printWindow.document.write(contentToPrint);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };

    const handleDownload = () => {
        const contentToDownload = typeof data === 'string' ? data : data?.content || '';
        const blob = new Blob([contentToDownload], { type: 'text/html' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${isSubmitted ? 'survey_results' : 'survey_progress'}.html`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    };

    if (!show) return null;

    const contentToRender = typeof data === 'string' ? data : data?.content || '';
    const isDataConfidentiality = title === "Data Confidentiality & Privacy";

    return (
        <div className={`modal-overlay ${show ? 'show' : ''}`}>
            <div className={`modal-container ${small ? 'small' : ''}`}>
                <div className="modal-header">
                    <h2>{title}</h2>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-content">
                    {contentToRender && Parser(contentToRender)}
                </div>
                <div className="modal-footer">
                    {/* {showSubmitButton && (
                        <button className="submit-button" onClick={onSubmit}>
                            Submit Survey
                        </button>
                    )} */}
                    {!isDataConfidentiality && (
                        <button 
                            className="submit-button" 
                            onClick={handleDownload}
                            style={{ backgroundColor: 'var(--ifia-blue)', marginLeft: '10px' }}
                        >
                            <i className="fas fa-download"></i> Download {isSubmitted ? 'Results' : 'Progress'}
                        </button>
                    )}
                    <button className="close-button" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InfoModal;
